/* eslint-disable no-unused-vars */

import React from "react";
import ClientList from "./ClientList";
const CPMasterLists = () => {
  return (
    <div className="p-1">
      {/* <Heading title={"Master List"} /> */}
      <div className="global-card-tab-container">
        <ClientList />
        {/* <Tabs
          activeKey={activeKey}
          destroyInactiveTabPane={destroy}
          onChange={changeTab}
          items={[
            {
              label: "Client list",
              key: "1",
              children: <ClientList />,
            },
          ]}
        /> */}
      </div>
    </div>
  );
};

export default CPMasterLists;
